import { combineReducers } from 'redux'

import agendamento from './modules/agendamento/reducer'
import colaboradores from './modules/colaboradores/reducer'

export default combineReducers ({
    agendamento, colaboradores
})